import React, { useState, useEffect } from 'react';

export function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const hasAccepted = localStorage.getItem('cookiesAccepted');
    if (!hasAccepted) {
      // Slight delay to show banner after page loads
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptAllCookies = () => {
    localStorage.setItem('cookiesAccepted', 'all');
    setIsVisible(false);
  };

  const acceptNecessaryCookies = () => {
    localStorage.setItem('cookiesAccepted', 'necessary');
    setIsVisible(false);
  };

  const toggleDetails = () => {
    setShowDetails(!showDetails);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 px-4 py-2">
      <div className="max-w-screen-lg mx-auto">
        {!showDetails ? (
          // Minimalist banner
          <div className="bg-white/90 backdrop-blur-sm rounded-lg shadow-sm border border-slate-200 py-2 px-3">
            <div className="flex items-center justify-between gap-4">
              <div className="flex items-center">
                <svg className="w-4 h-4 text-blue-600 mr-2 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <p className="text-xs text-slate-600">
                  This site uses cookies to enhance your experience.
                  <button 
                    onClick={toggleDetails}
                    className="text-blue-600 hover:underline ml-1 inline-flex items-center"
                  >
                    Details
                    <svg className="w-3 h-3 ml-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                </p>
              </div>
              <div className="flex items-center gap-2 shrink-0">
                <button 
                  onClick={acceptNecessaryCookies}
                  className="text-xs bg-white border border-blue-200 text-blue-600 px-2 py-1 rounded hover:bg-blue-50 transition-all"
                >
                  Necessary Only
                </button>
                <button 
                  onClick={acceptAllCookies}
                  className="text-xs bg-blue-600 text-white px-2 py-1 rounded hover:bg-blue-700 transition-all"
                >
                  Accept All
                </button>
              </div>
            </div>
          </div>
        ) : (
          // Detailed version when expanded
          <div className="bg-white rounded-lg shadow-sm border border-slate-200 p-3">
            <div className="flex justify-between items-start mb-3">
              <h3 className="text-sm font-medium text-slate-800">Cookie Settings</h3>
              <button 
                onClick={toggleDetails}
                className="text-xs text-blue-600 hover:underline inline-flex items-center"
              >
                Back to simple view
                <svg className="w-3 h-3 ml-0.5 transform rotate-180" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
            </div>
            
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-3">
              <div className="bg-slate-50 rounded p-2 text-xs">
                <h4 className="font-medium text-slate-800">Essential Cookies</h4>
                <p className="text-slate-600">Necessary for the website to function.</p>
              </div>
              <div className="bg-slate-50 rounded p-2 text-xs">
                <h4 className="font-medium text-slate-800">Analytics Cookies</h4>
                <p className="text-slate-600">Allow us to analyze site usage.</p>
              </div>
              <div className="bg-slate-50 rounded p-2 text-xs">
                <h4 className="font-medium text-slate-800">Marketing Cookies</h4>
                <p className="text-slate-600">Used to display relevant ads.</p>
              </div>
            </div>
            
            <div className="flex justify-end gap-2">
              <button 
                onClick={acceptNecessaryCookies}
                className="text-xs bg-white border border-blue-200 text-blue-600 px-2 py-1 rounded hover:bg-blue-50 transition-all"
              >
                Necessary Only
              </button>
              <button 
                onClick={acceptAllCookies}
                className="text-xs bg-blue-600 text-white px-2 py-1 rounded hover:bg-blue-700 transition-all"
              >
                Accept All
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default CookieConsent; 